import React, { useState, useEffect, useCallback } from "react";
import { Toaster, toast } from "react-hot-toast";
import axios from "axios";
import { API_URL, baseurl } from '../../../_config';
import Layout from "../../shared/Layout";
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { GetProductSubCategoryByCategoryId, GetProductSubCategoryByMultiCategoryId, IsFavProductDetailById, IsStockProductDetailById } from "../../../_services";
import { Switch } from 'antd';
import { Modal } from 'react-bootstrap';
import ReactQuill from 'react-quill'; import 'react-quill/dist/quill.snow.css';


const ProductDetail = () => {
    const jwtToken = localStorage.getItem('jwtToken');
    const navigate = useNavigate();
    const [isFormopen, setIsFormopen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [productData, setProductData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [subCategoryData, setSubCategoryData] = useState([]);
    const [rSubCategoryData, setRsubCategoryData] = useState();
    const [texType, setTexType] = useState([]);
    const [productId, setProductId] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [activeIndex, setActiveIndex] = useState(null);

    const [formData, setFormData] = useState({
        productId: 0,
        productCategoryId: 0,
        productSubCategoryId: 0,
        productName: '',
        displayName: '',
        shortDesc: '',
        displayDesc: '',
        salePrice: 0,
        mrp: 0,
        taxId: null,
        amazoneUrl: '',
        isDisplay: true,
        isActive: true,
        createdBy: 0,
        rcategoryId: "",
        rsubCategoryId: "",
        metaTag: ''
    });

    const handleReset = () => {
        setFormData({
            productCategoryId: 0,
            productSubCategoryId: 0,
            productName: '',
            displayName: '',
            displayDesc: '',
            shortDesc: '',
            salePrice: 0,
            mrp: 0,
            taxId: null,
            amazoneUrl: '',
            isDisplay: true,
            isActive: true,
            rcategoryId: "",
            rsubCategoryId: "",
            metaTag: ''
        });

        // setRsubCategoryData([]);
    };

    const getShortDescription = (description, wordLimit) => {
        if (!description) return '';
        const text = description.replace(/<\/?[^>]+(>|$)/g, "").trim();
        const words = text.split(/\s+/);
        return words.length > wordLimit
            ? words.slice(0, wordLimit).join(' ') + '...'
            : words.join(' ');
    };

    const handleModalToggle = (index) => {
        setActiveIndex(index);
        setShowModal(!showModal);
    };

    const fetchCategoryData = useCallback(async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL?.GetProductCategory}`);

            if (response.status === 200) {
                if (response.data.isSuccess === 200) {
                    setCategoryData((prevData) => {
                        if (JSON.stringify(prevData) !== JSON.stringify(response.data.data)) {
                            return response.data.data;
                        }
                        return prevData;
                    });
                }
            } else {
                toast.error("Failed to fetch Category Data");
            }
        } catch (error) {
            setCategoryData([])
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchSubCategoryData = useCallback(async (id) => {
        if (!id) {
            setSubCategoryData([]);
            return;
        }

        try {
            const res = await GetProductSubCategoryByCategoryId(id);
            if (res.isSuccess === 200) {

                if (res.data && res.data.length > 0) {
                    setSubCategoryData((prevData) => {
                        if (JSON.stringify(prevData) !== JSON.stringify(res.data)) {
                            return res.data;
                        }
                        return prevData;
                    });
                } else {
                    setSubCategoryData([]);
                }
            } else {
                setSubCategoryData([]);
            }
        } catch (error) {
            setSubCategoryData([]);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchRSubCategoryData = useCallback(async (ids) => {
        if (!ids) {
            alert("No categories to fetch subcategories for.");
            return;
        }

        try {
            const results = await Promise.all(ids.map((id) => GetProductSubCategoryByMultiCategoryId(id)));

            const flatSubCategoryData = results.reduce((acc, res) => {
                if (res.isSuccess === 200 && res.data && res.data.length > 0) {
                    return [...acc, ...res.data];
                }
                return acc;
            }, []);

            setRsubCategoryData(flatSubCategoryData);
        } catch (error) {
            setRsubCategoryData([]);
        } finally {
            setLoading(false);
        }
    }, []);

    const getTexType = useCallback(async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL?.GetTaxType}`, {
                headers: {
                    'Authorization': `Bearer ${jwtToken}`, // Set the Authorization header
                },
            });

            if (response.status === 200) {
                if (response.data.isSuccess === 200) {
                    setTexType((prevData) => {
                        if (JSON.stringify(prevData) !== JSON.stringify(response.data.data)) {
                            return response.data.data;
                        }
                        return prevData;
                    });
                }
            } else {
                setTexType([]);
            }
        } catch (error) {
            setTexType([]);
        } finally {
            setLoading(false);
        }
    }, [jwtToken]);

    const fetchProductData = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL?.GetProductDetail}`);
            if (response.status === 200) {
                if (response.data.isSuccess === 200 && response.data?.data.length > 0) {
                    setProductData((prevData) => {
                        if (JSON.stringify(prevData) !== JSON.stringify(response.data?.data)) {
                            const sortedData = response.data?.data?.sort((a, b) => {
                                return new Date(b.createdDate) - new Date(a.createdDate);
                            });

                            return sortedData;
                        }
                        return prevData;
                    })
                } else if (response.data.isSuccess === 404 && response.data === null) {
                    setProductData([]);
                }
            } else {
                setProductData([]);
            }
        } catch (error) {
            setProductData([]);
        } finally {
            setLoading(false);
        }
    };

    // Handle category selection
    const handleCategoryChange = (e) => {
        const categoryId = e.target.value;

        setFormData({
            ...formData,
            productCategoryId: categoryId,
            productSubCategoryId: ''
        });

        fetchSubCategoryData(categoryId);
    };

    const handleRCategoryChange = (event) => {
        const selectedCategoryId = event.target.value;
        let updatedCategories = formData.rcategoryId.split(',').filter(Boolean);

        if (event.target.checked) {
            updatedCategories.push(selectedCategoryId);
            fetchRSubCategoryData(updatedCategories);
        } else {
            updatedCategories = updatedCategories.filter(id => id !== selectedCategoryId);

            setRsubCategoryData((prevData) => {
                return prevData.filter((subCategory) => subCategory.productCategoryId !== Number(selectedCategoryId));
            });
        }

        setFormData((prevState) => ({
            ...prevState,
            rcategoryId: updatedCategories.join(','),
        }));
    };

    const handleSubCategoryChange = (event) => {
        const selectedSubCategoryId = event.target.value;
        let updatedSubCategories = formData.rsubCategoryId.split(',').filter(Boolean);

        if (event.target.checked) {
            updatedSubCategories.push(selectedSubCategoryId);
        } else {
            updatedSubCategories = updatedSubCategories.filter(id => id !== selectedSubCategoryId);
        }

        setFormData((prevState) => ({
            ...prevState,
            rsubCategoryId: updatedSubCategories.join(','),
        }));
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    // Handle the description input change
    const handleDescriptionChange = (value) => {
        setFormData(prev => ({
            ...prev,
            displayDesc: value
        }));
    };

    const onSave = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${baseurl}${API_URL?.SaveProductDetail}`, formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200) {
                if (response.data.isSuccess === 200) {
                    fetchProductData();
                    toast.success("Save Successfully");
                    setProductId(0)
                    handleReset();
                    setIsFormopen(false);
                    localStorage.setItem('SAproductId', response?.data?.data?.productId || productId);
                    if (response.data.data === null) {
                        navigate(`/productdetail/${productId}`);
                    } else {
                        navigate(`/productdetail/${response.data.data.productId}`);
                    }
                }
            } else {
                toast.error("Failed to submit form data");
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
    };

    const onEdit = (item) => {
        setRsubCategoryData([]);
        setProductId(item?.productId)
        setIsFormopen(true);
        setFormData({
            ...formData,
            productId: item.productId,
            productCategoryId: item?.productCategoryId,
            productSubCategoryId: item?.productSubCategoryId,
            productName: item?.productName,
            displayName: item?.displayName,
            shortDesc: item?.shortDesc,
            displayDesc: item?.displayDesc,
            isDisplay: item?.isDisplay,
            isActive: item?.isActive,
            salePrice: item?.salePrice,
            mrp: item?.mrp,
            taxId: item?.taxId,
            amazoneUrl: item?.amazoneUrl,
            rcategoryId: item?.rcategoryId || "",
            rsubCategoryId: item?.rsubCategoryId || "",
            metaTag: item?.metaTag
        });
        fetchSubCategoryData(item?.productCategoryId);
        if (item?.rcategoryId) {
            const categoryIds = item?.rcategoryId.split(',');
            fetchRSubCategoryData(categoryIds);
        }
    }

    const onDelete = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");

        if (!isConfirmed) {
            return;
        }

        try {
            const response = await axios.get(`${baseurl}${API_URL?.DeleteProductDetailById}`, {
                params: {
                    pProductDetailId: id
                }
            });

            if (response.status === 200 && response.data.isSuccess === 200) {
                toast.success("Delete Successfully");
                fetchProductData();
            } else {
                toast.error("Failed to delete category");
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
    };

    const isDisplayToggle = async (id) => {
        try {
            const response = await axios.get(`${baseurl}${API_URL?.IsDisplayProductDetailById}`, {
                params: {
                    pProductDetailId: id
                }
            });
            if (response.status === 200 && response.data.isSuccess === 200) {
                toast.success("Update Successfully");
                fetchProductData();
            } else {
                toast.error("Failed to Update category");
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
    }

    const isCustomizedToggle = async (id) => {
        try {
            const response = await axios.get(`${baseurl}${API_URL?.IsCustomProductDetailById}`, {
                params: {
                    pProductDetailId: id
                }
            });
            if (response.status === 200 && response.data.isSuccess === 200) {
                toast.success("Update Successfully");
                fetchProductData();
            } else {
                toast.error("Failed to Update category");
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
    }

    const IsFavProduct = async (id) => {
        try {
            await IsFavProductDetailById(id);
            fetchProductData();
        } catch (error) {
            toast.error("Please try again later.");
        }
    }

    const IsStockProduct = async (id) => {
        try {
            await IsStockProductDetailById(id);
            fetchProductData();
        } catch (error) {
            toast.error("Please try again later.");
        }
    }

    const onOpen = () => {
        setProductId(0)
        handleReset();
        setIsFormopen(true)
    }

    const onClose = () => {
        setProductId(0)
        handleReset();
        setIsFormopen(false)
    }

    useEffect(() => {
        fetchCategoryData();
        fetchProductData();
        getTexType();
    }, [fetchCategoryData, getTexType]);

    useEffect(() => {
        if (searchTerm) {
            const filtered = productData.filter(item =>
                item.productName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.displayName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.displayDesc.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(productData);
        }
    }, [searchTerm, productData]);

    const productDetailByID = (productId) => {
        localStorage.setItem('SAproductId', productId);
        sessionStorage.setItem("activeItemsUrl", `/productdetail/${productId}`)
        navigate(`/productdetail/${productId}`);
    };

    const isHomeToggle = async (id) => {
        try {
            const response = await axios.get(`${baseurl}${API_URL?.IsHomeProductDetailById}`, {
                params: {
                    pProductDetailId: id
                }
            });
            if (response.status === 200 && response.data.isSuccess === 200) {
                toast.success("Update Successfully");
                fetchProductData();
            } else {
                toast.error("Failed to Update category");
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
    }

    const isOccasionToggle = async (id) => {
        try {
            const response = await axios.get(`${baseurl}${API_URL?.IsOccasionProductDetailById}`, {
                params: {
                    pProductDetailId: id
                }
            });
            if (response.status === 200 && response.data.isSuccess === 200) {
                toast.success("Update Successfully");
                fetchProductData();
            } else {
                toast.error("Failed to Update category");
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
    }

    useEffect(() => {
        if (selectedCategory === 'All') {
            setFilteredData(productData);
        } else {
            const newFiltered = productData.filter(
                (item) => item.categoryName === selectedCategory
            );
            setFilteredData(newFiltered);
        }
    }, [selectedCategory, productData]);

    const handleCategoryFilter = (e) => {
        setSelectedCategory(e.target.value);
    };

    const columns = [
        {
            name: 'SR.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'Product Name',
            selector: row => (
                <div className="table_text">
                    <span onClick={() => productDetailByID(row.productId)} >
                        {row.productName}
                    </span>
                </div>
            ),
            sortable: false,
            width: '200px'
        },
        {
            name: 'Category Name',
            selector: row => row.categoryName,
            sortable: false,
            width: '150px',
        },
        {
            name: 'Sub Category Name',
            selector: row => row.productSubCategoryName,
            sortable: false,
            width: '160px',
        },
        {
            name: 'Short Description',
            selector: (row, index) => (
                <div >
                    <p className='mb-0' dangerouslySetInnerHTML={{ __html: row.shortDesc }} />
                </div>
            ),
            sortable: false,
            width: '300px'
        },
        {
            name: 'Product Description',
            selector: (row, index) => (
                <div >
                    <p style={{ cursor: 'pointer' }} className='mb-0' onClick={() => handleModalToggle(index)}>{getShortDescription(row?.displayDesc, 15)}...</p>
                </div>
            ),
            sortable: false,
            width: '300px'
        },
        {
            name: 'Meta Tag',
            selector: (row, index) => (
                <div >
                    <p className='mb-0'>{row?.metaTag}</p>
                </div>
            ),
            sortable: false,
            width: '200px'
        },
        {
            name: 'isDisplay',
            selector: row => (
                <span
                    onClick={() => isDisplayToggle(row.productId)}
                    style={{ cursor: 'pointer' }}
                >
                    {row.isDisplay ? (
                        <svg fill="none" height="20" viewBox="0 0 12 12" width="20" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="M0 9h5v2H3v1h6v-1H7v-2h5V0H0z" fill="#526484" stroke="none" />
                            </g>
                        </svg>
                    ) : (
                        <svg viewBox="0 0 20 20" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="M19 0H1c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h5v2h-1c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1h-1v-2h5c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-7 18h-4v-2h4zm6-4H2V4h16z" fill="#526484" />
                                <path d="M7.3 10.7c.4.4 1 .4 1.4 0l1.3-1.3 1.3 1.3c.4.4 1 .4 1.4 0s.4-1 0-1.4l-1.3-1.3 1.3-1.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-1.3 1.3-1.3-1.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l1.3 1.3-1.3 1.3c-.4.4-.4 1 0 1.4z" fill="#526484" />
                            </g>
                        </svg>
                    )}
                </span>
            ),
            sortable: false,
            width: "90px"
        },
        {
            name: 'isCustomized',
            selector: row => (
                <button
                    onClick={() => isCustomizedToggle(row.productId)}
                    className={`${row.isCustom ? 'active-toggle' : 'dactive-toggle'}`}
                >
                    {row.isCustom ? "Custom" : "Not Custom"}
                </button>
            ),
            sortable: false,
            width: "130px"
        },
        {
            name: 'isHome',
            selector: row => (
                <button
                    onClick={() => isHomeToggle(row.productId)}
                    className={`${row.isHome ? 'active-toggle' : 'dactive-toggle'}`}
                >
                    {row.isHome ? "Yes" : "No"}
                </button>
            ),
            sortable: false,
            width: "80px"
        },
        {
            name: 'isOccasion',
            selector: row => (
                <button
                    onClick={() => isOccasionToggle(row.productId)}
                    className={`${row.isOccasion ? 'active-toggle' : 'dactive-toggle'}`}
                >
                    {row.isOccasion ? "Yes" : "No"}
                </button>
            ),
            sortable: false,
            width: "100px"
        },
        {
            name: 'inStock',
            selector: row => (
                <button
                    onClick={() => IsStockProduct(row.productId)}
                >
                    {row.stockStatus ? <Switch defaultChecked /> : <Switch />} {/* Display switch based on stock status */}
                </button>
            ),
            sortable: false,
            width: "80px"
        },
        {
            name: 'isRecommended',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span title='Recommended' onClick={() => IsFavProduct(row.productId)} className="delete_icon_weepr">
                        {(row.isFav) ?
                            <svg
                                id="Capa_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                version="1.1"
                                viewBox="0 0 508.186 508.186"
                                width="300"
                                height="300"
                            >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g>
                                        <g clipRule="evenodd" fillRule="evenodd">
                                            <path
                                                d="m102.775 31.03h302.636c10.699 0 19.349 8.657 19.349 19.41v416.636c0 12.572-.97 13.031-10.68 5.103l-150.174-122.625c-5.711-4.663-13.915-4.663-19.626 0l-150.174 122.625c-9.771 7.979-10.68 7.548-10.68-5.103v-416.636c0-10.711 8.69-19.41 19.349-19.41zm-50.379 436.046c0 38.817 31.301 53.663 61.336 29.138l140.74-114.303 139.982 114.303c29.965 24.468 61.336 9.611 61.336-29.138v-416.636c0-27.884-22.537-50.44-50.379-50.44h-302.636c-27.805 0-50.379 22.599-50.379 50.44z"
                                                fill="#000000"
                                                fillOpacity="1"
                                            />
                                            <path
                                                d="m209.238 263.546 2.15-42.148c.195-3.814-1.025-7.566-3.424-10.537l-26.005-32.859 40.201-10.832c3.688-.994 6.879-3.312 8.964-6.512l23.128-35.018 22.811 35.018c2.085 3.2 5.276 5.519 8.964 6.512l40.534 11.072-26.338 32.618c-2.399 2.971-3.618 6.723-3.424 10.537l2.764 42.266-39.93-15.263c-3.567-1.364-7.512-1.364-11.08 0zm100.872 37.37c10.474 4.004 21.606-4.084 21.035-15.283l-2.977-59.988 37.598-46.563c7.045-8.724 2.793-21.811-8.035-24.728l-57.954-15.677-32.684-50.175c-6.12-9.396-19.88-9.396-26 0l-32.525 50.194-58.113 15.659c-10.827 2.917-15.079 16.004-8.035 24.728l37.688 46.409-3.067 60.142c-.571 11.199 10.561 19.286 21.035 15.283l56.017-21.553z"
                                                fill="#000000"
                                                fillOpacity="1"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            : <svg
                                fill="none"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g fill="rgb(0,0,0)">
                                    <path
                                        clipRule="evenodd"
                                        d="M21.5821 1.41792c.3906.39053.3905 1.0237 0 1.41421l-2.7931 2.79287 2.7931 2.79287c.3905.39051.3906 1.02368 0 1.41421-.3905.39052-1.0236.39052-1.4142.00005l-2.7931-2.79296-2.7927 2.7925c-.3905.39053-1.0237.39053-1.4142-.00005-.3905-.39053-.3905-1.0237 0-1.41421l2.7926-2.79241-2.7926-2.79241c-.3905-.39051-.3905-1.02368 0-1.41421.3905-.39054 1.0237-.39056 1.4142-.00005l2.7927 2.7925 2.7931-2.79296c.3906-.39051 1.0237-.39049 1.4142.00005z"
                                        fillRule="evenodd"
                                    />
                                    <path d="M11.3831 1.92387c.0145-.18076.0218-.27115.0113-.31643-.0272-.118-.086-.18172-.2015-.21837-.0443-.01406-.1173-.01406-.2633-.01406h-.1092c-1.8393-.00001-3.2934-.00003-4.43082.14731-1.16746.15122-2.11407.46941-2.86337 1.19132-.75321.72568-1.08878 1.6488-1.24756 2.78662-.15368 1.10125-.15366 2.50681-.15364 4.27418l-.00001 8.39636c-.00004 1.0975-.00007 2.0095.10533 2.6947.10905.709.36324 1.399 1.06425 1.7734.62518.3338 1.31282.2659 1.89586.0889.5897-.179 1.1891-.5039 1.73791-.8507.55404-.3501 1.15285-.7903 1.62519-1.1394.46282-.3421.83454-.6169 1.11836-.7878.3996-.2406.6519-.3914.8564-.4878.1887-.0889.2804-.1031.3467-.1031s.158.0142.3467.1031c.2046.0964.4568.2472.8564.4878.2838.1709.6556.4457 1.1184.7878.4723.3491 1.0711.7893 1.6252 1.1394.5488.3468 1.1482.6717 1.7379.8507.583.177 1.2707.2449 1.8958-.0889.701-.3744.9552-1.0644 1.0643-1.7734.1054-.6852.1053-1.5971.1053-2.6946v-6.5339c0-.1591 0-.2387-.0304-.3009-.0303-.0623-.1057-.1211-.2563-.2388-.0801-.0626-.1573-.1308-.231-.2045l-1.3083-1.30815c-.2-.19998-.3-.29997-.4242-.29997-.1243 0-.2243.09999-.4243.29997l-1.3078 1.30775c-.9763.9763-2.5592.9762-3.5355-.0001-.9763-.97639-.9762-2.5593.0001-3.53557l1.3075-1.30744c.2-.20001.3-.30001.3-.42428s-.1-.22427-.3-.42428l-1.3075-1.30743c-.5395-.53948-.7809-1.26419-.7242-1.96943z" />
                                </g>
                            </svg>
                        }
                    </span>
                </div>
            ),
            sortable: false,
            width:'130px'
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span title='Edit' onClick={() => onEdit(row)} className="edit_icon_wepper">
                        <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#526484" />
                                <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="url(#gradient1)" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#526484" />
                                        <stop offset="100%" stopColor="#0063ff" />
                                    </linearGradient>
                                </defs>
                            </g>
                        </svg>
                    </span>
                    <span title='Delete' onClick={() => onDelete(row.productId)} className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false
        }
    ];

    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            [{ 'align': [] }],
            ['link'],
            ['image']
        ],
    };

    return (
        <Layout>
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Product Detail</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                        <div className="search-container col-md-6">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <div className="add_btn">
                            <button onClick={onOpen}>Add Product</button>
                        </div>
                    </div>
                </div>
                <div className="filter_main">
                    <div className="filter_inner d-flex align-items-center gap-4">
                        <div className="d-flex filter_admin_size gap-3 align-items-center mt-4">
                            <label htmlFor="sizeFilter">Category : </label>
                            <div className='color_filter_detail'>
                                <select
                                    id="sizeFilter"
                                    className="form-select"
                                    value={selectedCategory}
                                    onChange={handleCategoryFilter}
                                >
                                    <option value="All">All</option>
                                    {categoryData.map((item, i) => (
                                        <option key={i} value={item?.categoryName}>
                                            {item?.categoryName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="datatable mt-2">
                    <DataTable
                        columns={columns}
                        data={filteredData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>

                <div id="entryformContainer" className={`adminform entryform product_detail_form ${isFormopen ? 'open' : ''}`}>
                    <div className="closebtn">
                        <button className="" onClick={onClose} >
                            <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g id="Layer_x0020_1">
                                        <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                        <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>
                    <div className="enForm">
                        <div className="text-center form-heading">
                            <h4>Add Product Detail</h4>
                        </div>
                        <form onSubmit={onSave}>
                            {/* <div className="form-group">
                                <label htmlFor="exampleFormControlInput1">Show Order</label>
                                <input type="text" className="form-control" id="showOrder" name="showOrder" placeholder="Show Order" value={formData.showOrder} onChange={handleChange} />
                            </div> */}
                            <div className="row">
                                <div className="form-group col-sm-6 col-12">
                                    <label htmlFor="categorySelect">Product Category</label>
                                    <select id="categorySelect" name="productCategoryId" className="form-control" value={formData.productCategoryId || ""} onChange={handleCategoryChange} required>
                                        <option value="" className="select_default">Select a category</option>
                                        {Array.isArray(categoryData) && categoryData.length > 0 ? (
                                            categoryData.map((category) => (
                                                <option key={category?.productCategoryId} value={category?.productCategoryId}>
                                                    {category?.categoryName}
                                                </option>
                                            ))
                                        ) : null}
                                    </select>
                                </div>
                                <div className="form-group col-sm-6 col-12">
                                    <label htmlFor="categorySelect">Product Sub Category</label>
                                    <select id="subcategorySelect" name="productSubCategoryId" className="form-control" value={formData.productSubCategoryId || ""} onChange={handleChange} required>
                                        <option value="" className="select_default">Select a sub category</option>
                                        {subCategoryData.length === 0 ? (
                                            <option value="" disabled>No subcategories available</option>
                                        ) : (
                                            subCategoryData.map((category) => (
                                                <option key={category?.productSubCategoryId} value={category?.productSubCategoryId}>
                                                    {category?.productSubCategoryName}
                                                </option>
                                            ))
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className="form-group related_category">
                                <label>Related Categories</label>
                                <div className="category-dropdown row mt-1">
                                    {Array.isArray(categoryData) && categoryData.length > 0 ? (
                                        categoryData.map((category) => (
                                            <div className="category_dropdown_inner col-3" key={category?.productCategoryId}>
                                                <input
                                                    type="checkbox"
                                                    id={`category-${category?.productCategoryId}`}
                                                    value={category?.productCategoryId}
                                                    checked={(formData.rcategoryId || '').split(',').includes(String(category?.productCategoryId))}
                                                    onChange={handleRCategoryChange}
                                                />
                                                <p className="mb-0" htmlFor={`category-${category?.productCategoryId}`}>
                                                    {category?.categoryName}
                                                </p>
                                            </div>
                                        ))
                                    ) : (
                                        <p>No categories available</p>
                                    )}
                                </div>
                            </div>


                            {Array.isArray(rSubCategoryData) && rSubCategoryData.length > 0 && (
                                <div className="form-group related_category">
                                    <label>Related Sub Categories</label>
                                    <div className="category-dropdown row mt-1">
                                        {rSubCategoryData.map((subcategory) => (
                                            <div className="category_dropdown_inner col-3" key={subcategory?.productSubCategoryId}>
                                                <input
                                                    type="checkbox"
                                                    id={`subcategory-${subcategory?.productSubCategoryId}`}
                                                    value={subcategory?.productSubCategoryId}
                                                    checked={formData.rsubCategoryId.split(',').includes(String(subcategory?.productSubCategoryId))}
                                                    onChange={handleSubCategoryChange}
                                                />
                                                <p className="mb-0" htmlFor={`subcategory-${subcategory?.productSubCategoryId}`}>
                                                    {subcategory?.productSubCategoryName}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div className="row">
                                <div className="form-group col-md-6">
                                    <label htmlFor="exampleFormControlInput1">Product Name</label>
                                    <input type="text" className="form-control" id="productName" name="productName" placeholder="Product Name" value={formData.productName} onChange={handleChange} required />
                                </div>

                                <div className="form-group col-md-6">
                                    <label htmlFor="exampleFormControlInput1">Display Name</label>
                                    <input type="text" className="form-control" id="displayName" name="displayName" placeholder="Display Name" value={formData.displayName} onChange={handleChange} required />
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="exampleFormControlInput1">Short Description{`(Max Limit: 200 Characters)`}</label>
                                <textarea type="text" className="form-control" id="shortDesc" name="shortDesc" placeholder="Short Description" value={formData.shortDesc} onChange={handleChange} required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="exampleFormControlInput1">Display Description{`(Max Limit: 400 Characters)`}</label>
                                {/* <input type="text" className="form-control" id="displayDesc" name="displayDesc" placeholder="Display Description" value={formData.displayDesc} onChange={handleChange} required /> */}
                                <ReactQuill
                                    value={formData.displayDesc}
                                    onChange={handleDescriptionChange}
                                    modules={modules}
                                    theme="snow"
                                    placeholder="Enter description here"
                                />
                            </div>

                            <div className="row">
                                <div className="form-group col-sm-6 col-12">
                                    <label htmlFor="exampleFormControlInput1">SalePrice</label>
                                    <input type="text" className="form-control" id="salePrice" name="salePrice" placeholder="SalePrice" value={formData.salePrice || ''} onChange={handleChange} required />
                                </div>
                                <div className="form-group col-sm-6 col-12">
                                    <label htmlFor="exampleFormControlInput1">Mrp</label>
                                    <input type="text" className="form-control" id="mrp" name="mrp" placeholder="Mrp" value={formData.mrp || ''} onChange={handleChange} required />
                                </div>
                            </div>

                            <div className="row">
                                <div className="form-group col-md-6">
                                    <label htmlFor="taxId">TaxId</label>
                                    <select id="taxId" name="taxId" className="form-control" value={formData.taxId || ""} onChange={handleChange} required>
                                        <option value="">Select a TaxId</option>
                                        {texType.map((textype) => (
                                            <option key={textype?.taxId} value={textype?.taxId}>
                                                {textype?.taxDisplay}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group col-md-6">
                                    <label htmlFor="exampleFormControlInput1">Meta Tags</label>
                                    <input type="text" className="form-control" id="metaTag" name="metaTag" placeholder="Meta Tag" value={formData.metaTag} onChange={handleChange} />
                                </div>
                            </div>

                            {/* <div className="row mt-2"> */}
                            {/* <div className="form-group d-flex col-6">
                                    <div className="form-check">
                                        <input type="checkbox" className="form-check-input" id="isDisplay" name="isDisplay" value={formData.isDisplay} onChange={handleChange} />
                                    </div>
                                    <label htmlFor="exampleFormControlInput1">isDisplay</label>
                                </div> */}
                            {/* <div className="form-group d-flex col-6">
                                    <div className="form-check">
                                        <input type="checkbox" className="form-check-input" id="isActive" name="isActive" value={formData.isActive} onChange={handleChange} />
                                    </div>
                                    <label htmlFor="exampleFormControlInput1">isActive</label>
                                </div> */}
                            {/* </div> */}

                            <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                                <div className="submit-btn pt-2">
                                    <button type="submit">{productId ? 'Update' : 'Submit'}</button>
                                </div>
                                <div className="reset-btn pt-2">
                                    <button className="" onClick={handleReset}>Reset</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                {/* Modal */}

                {activeIndex !== null && (
                    <Modal
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        dialogClassName="modal-xl"
                        centered
                    >
                        <div>
                            <Modal.Body>
                                <div className="popup_content">

                                    <div className="description-box">
                                        <div
                                            className="word-wrap"
                                            dangerouslySetInnerHTML={{ __html: productData[activeIndex]?.displayDesc }}
                                        />
                                    </div>
                                </div>
                            </Modal.Body>
                        </div>
                    </Modal>
                )}
                <Toaster position="top-right" />
            </div>
        </Layout>
    )
}

export default ProductDetail;